import React, { useState, useRef, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { Info } from 'lucide-react';
import styles from './InfoTooltip.module.css';

interface InfoTooltipProps {
  text: string;
  size?: number;
}

export const InfoTooltip: React.FC<InfoTooltipProps> = ({ text, size = 14 }) => {
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0, position: 'above' as 'above' | 'below' });
  const iconRef = useRef<HTMLSpanElement>(null);

  const show = useCallback(() => {
    if (!iconRef.current) return;
    const rect = iconRef.current.getBoundingClientRect();
    const showBelow = rect.top < 120;
    setCoords({
      top: showBelow ? rect.bottom + 6 : rect.top - 6,
      left: rect.left + rect.width / 2,
      position: showBelow ? 'below' : 'above',
    });
    setVisible(true);
  }, []);

  if (!text) return null;

  return (
    <>
      <span
        ref={iconRef}
        className={styles.wrapper}
        onMouseEnter={show}
        onMouseLeave={() => setVisible(false)}
      >
        <Info size={size} className={styles.icon} />
      </span>
      {visible && createPortal(
        <span
          className={`${styles.tooltip} ${styles[coords.position]}`}
          style={{
            position: 'fixed',
            left: coords.left,
            top: coords.top,
          }}
        >
          {text}
        </span>,
        document.body
      )}
    </>
  );
};
